const tabs = (() => {
  const initBlock = el => {
    handleTabsSwitching(el);
  };
  const handleTabsSwitching = el => {
    el.querySelectorAll('[data-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        resetTabs(el);
        const content = el.querySelector('[data-tab-content][data-id="' + tab.dataset.id + '"]');
        tab.classList.add('active');
        content.classList.add('active');
      })
    });
  };
  const resetTabs = el => {
    el.querySelectorAll('[data-tab]').forEach(tab => {
      tab.classList.remove('active');
    });
    el.querySelectorAll('[data-tab-content]').forEach(content => {
      content.classList.remove('active');
    });
  };
  return {initBlock};
})();
ControlBinders.register(`[data-tabs]`, el => tabs.initBlock(el));